import * as React from 'react';
import { Grid } from "@material-ui/core";

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";

import Status from '../../../Common/Status';
import documentIcon from '../../../utils/assests/pending.png';
import Header from '../../../Common/header';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
    })
);

export default function PendingStatus() {

    const history = useHistory()

    const onContinue = async (value: any) => { window.location.href = '/dashboard'};
    return (
        <div>
            <div>
            <Header pageName="Pending Status"/>
            </div>
        <Grid
            container
            direction="column"
            alignItems="center"
            justifyContent="center">
            <Grid container justifyContent="center">
          
                <Grid item xs={12} sm={6} md={3} lg={3} onClick={onContinue}>
                    <Status
                        image={documentIcon}
                        heading='Application Pending'
                        desc='You don not currently meet our criteria and we can not process your application at this time. However, you might be eligible for offers soon. Stay tuned on the StashFin App to know more about your offers.'
                        buttonText="Close"
                    />
                </Grid>
            </Grid >
        </Grid >
        </div>

    )
}